// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1O4L0","container__legend":"styles_container__legend__0vVjf","container__chart":"styles_container__chart__J98VI","sticker":"styles_sticker__qyndl"};